<template>
  <v-footer
    color="#ef771e"
    class="footer"
  >
    <v-row
      justify="center"
    >
      <v-col
        class="text-center white--text"
        cols="12"
        sm="10" 
      >
        <div style="margin-bottom:10px;">
          <a class="link_footer_icon" href="https://www.facebook.com/inversgruppe/?locale=de_DE" target="_blank">
            <span class="footer_icon facebook_icon  fa-2x ga-right"  style="margin:6px; padding-bottom:10px;">

              <i class='fab fa-facebook-square'></i>
              
            </span>
          </a>
          <a class="link_footer_icon" href="https://www.instagram.com/invers_gruppe/?hl=de" target="_blank">
            <span class="footer_icon instagram_icon  fa-2x ga-right" style="margin:6px; padding-bottom:10px;">
              <i class='fab fa-instagram'></i>
            </span>
          </a>
          <!-- <a class="link_footer_icon" href="https://www.xing.com/pages/inversgruppe" target="_blank">
            <span class="footer_icon xing_icon fa-2x ga-right" style="margin:6px; padding-bottom:10px;">
              <i class='fab fa-xing'></i>
            </span>
          </a>  -->
          <a class="link_footer_icon" href="https://de.linkedin.com/company/invers-gruppe" target="_blank">
            <span class="footer_icon linkedin_icon fa-2x ga-right" style="margin:6px; padding-bottom:10px;">
              <i class='fab fa-linkedin'></i>
            </span>
          </a>           
        </div>
        <p>
          <a href="https://www.invers-gruppe.de/kontakt.php" target="_blank">Kontakt</a><span> | </span>
          <a href="https://www.invers-gruppe.de/datenschutz.php" target="_blank">Datenschutz</a><span> | </span>
          <a href="https://www.invers-gruppe.de/impressum.php" target="_blank">Impressum</a><span> | </span>
          <a href="https://www.invers-gruppe.de/erstinformation.php" target="_blank">Erstinformation</a><span> | </span>
          <a href="https://www.invers-gruppe.de/beschwerden.php" target="_blank">Beschwerdemanagement</a><span> | </span>
        </p>
        <div>
          <p>Invers GmbH - Sportplatzweg 15 - 04178 Leipzig</p>
          <p>&copy; Copyright {{ new Date().getFullYear() }} Invers GmbH</p>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
    }),
  }
</script>
<style scoped>
.footer {
    padding: 50px 0;
    background-color: #EF771E;
    color: #fff;
    bottom: 0;
    z-index: 99;
    position: relative;
}
  
.footer a {
    font-weight: 400;
    color: #fff;
    text-decoration: none !important;

}

.footer a:hover {
    font-weight: 400;
    color: #fff;
    text-decoration: none !important;
    border-bottom: dotted #fff 1px;
}

.footer a.active {
    color: #fff !important
  }

        .fa-facebook-square:hover, .fa-thumbs-o-up:hover {
            color: #3B5998 !important;
            cursor: pointer;
        }
        .fa-instagram:hover {
            color: 	#FF00FF !important;
            cursor: pointer;
        }
        .fa-xing:hover {
            color: #008000 !important;
            cursor: pointer;
            }
        .fa-linkedin:hover {
            color: #2867B2 !important;
            cursor: pointer;
        }
        .link_footer_icon{
          color:#fff  !important;
          z-index: 100;
        }
        .link_footer_icon:hover{
            text-decoration: none;
            border: none !important;
        }
    
</style>